import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  SalesOrderSearchResult,
  SalesOrderSearch,
  SalesOrderSummaryResult,
  DeleteResponse,
} from "@/types/meesho/meeshoSalesOrder";


export const MeeshoSalesOrderApi = createApi({
  reducerPath: "MeeshoSalesOrderApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["meeshoSalesOrder"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadSalesOrder: builder.mutation({
      query: ({ formData }) => ({
        url: `/salesorder/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["meeshoSalesOrder"],
    }),
    searchOrders: builder.query<SalesOrderSearchResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/salesorder_search`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["meeshoSalesOrder"],
    }),
    exportSalesOrder: builder.mutation<Blob, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/salesorder_search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrders: builder.query<SalesOrderSummaryResult, SalesOrderSearch>({
      query: (input) => ({
        url: `/salesorder/salesorder_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshoSalesOrder"],
    }),
    // deleteSalesReturns: builder.mutation<DeleteResponse, string[]>({
    //   query: (ids) => ({
    //     url: "/salesorder/order-delete",
    //     method: "DELETE",
    //     body: { ids },
    //   }),
    //   invalidatesTags: ["meeshoSalesOrder"],
    // }),
    deleteSalesReturns: builder.mutation<DeleteResponse, string[]>({
      query: (ids) => ({
        url: "/salesorder/order-delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshoSalesOrder"],
    }),
  }),
});

export const {
  useUploadSalesOrderMutation,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery,
  useExportSalesOrderMutation,
  useSummaryOrdersQuery,
  useDeleteSalesReturnsMutation
} = MeeshoSalesOrderApi;
